export default function priceFormatter(sku){
  const startAtPrice = sku && sku.startsAtPrice.substr(1) * 1;

  return startAtPrice;
}

// Helper to remove the $ from the string coming in from sku and converting it to number.
